import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
var ClientKindFormComponent = /** @class */ (function () {
    function ClientKindFormComponent(errorsService, formBuilder, authService, snackBar, router, route) {
        this.errorsService = errorsService;
        this.formBuilder = formBuilder;
        this.authService = authService;
        this.snackBar = snackBar;
        this.router = router;
        this.route = route;
    }
    ClientKindFormComponent.prototype.ngOnInit = function () {
        this.id = this.route.snapshot.paramMap.get('id');
        this.initForm();
    };
    ClientKindFormComponent.prototype.initForm = function () {
        this.formGroup = this.formBuilder.group({
            kind: [null, [Validators.required]],
            isDefault: [null, []],
        });
        if (this.id) {
            this.loadInfos().catch(function (err) { return console.log(err); });
        }
    };
    ClientKindFormComponent.prototype.loadInfos = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authService.ClientKindFindOne(this.id).then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            return tslib_1.__generator(this, function (_a) {
                                this.formGroup.patchValue({
                                    kind: response.kindName,
                                    isDefault: response.isDefault,
                                });
                                return [2 /*return*/];
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ClientKindFormComponent.prototype.submit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (!this.formGroup.valid) {
                    this.snackBar.open('Preencha corretamente os campos e tente novamente.');
                    return [2 /*return*/, false];
                }
                data = {
                    kindName: this.formGroup.value.kind,
                    isDefault: !!this.formGroup.value.isDefault,
                };
                if (this.id) {
                    this.authService.ClientKindUpdate(this.id, data).then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        return tslib_1.__generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!response.isUpdated) return [3 /*break*/, 2];
                                    return [4 /*yield*/, this.router.navigate(['./dashboard/client-kind'])];
                                case 1:
                                    _a.sent();
                                    this.snackBar.open('Segmentação atualizada com sucesso.');
                                    _a.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); }, function (error) {
                        _this.snackBar.open(error.error.message);
                    });
                }
                else {
                    this.authService.ClientKindCreate(data).then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        return tslib_1.__generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!response.isCreated) return [3 /*break*/, 2];
                                    return [4 /*yield*/, this.router.navigate(['./dashboard/client-kind'])];
                                case 1:
                                    _a.sent();
                                    this.snackBar.open('Segmentação criado com sucesso.');
                                    _a.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); }, function (error) {
                        _this.snackBar.open(error.error.message);
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    return ClientKindFormComponent;
}());
export { ClientKindFormComponent };
